import React from 'react'
import Info from './Info';
import Product from './Product';
import Report from './Report';
import CompanyInfo from './CompanyInfo';
import { information , product } from './modal';
import './Style/Invoice.css'
import Image from './Image';

function Invoice() {

  let total = product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0)
  let discount = (product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0) * product.discount/100)  
  let lastPrice = total - discount

  
  var today = new Date();
  var date = today.getFullYear()+' - '+(today.getMonth()+1)+' - '+today.getDate();


  return <div className='invoice'>

      <div className='container'>

          <div className='row'>

            <div className='col-lg-4 col-md-12 col-sm-12 col-xs-12 left-side'>
                  <Image />
                  <Info data={information}/>
            </div>

            <div className='col-lg-8 col-md-12 col-sm-12 col-xs-12 right-side'>
                  <CompanyInfo data={information}/>
                  <Product data={product.info} DateDay={date}/>
                  <Report 
                    subTotal={total}
                    discount={discount}
                    lastPrice={lastPrice}
                    product={product}
                  />
            </div>

          </div>
      </div>
  </div>
}

export default Invoice